import { LinkContainer } from 'react-router-bootstrap';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import Stack from 'react-bootstrap/Stack';
import SlideCarousel from '../components/SlideCarousel';
import Ratio from 'react-bootstrap/Ratio';

const StyledSection = styled.section`
font-family: 'Roboto';

max-width: 1320px;
margin: 60px auto 0px auto;
padding: 12px 0px;
.header-card {
  color: #ffffff;
}
`

function MooringsAtPointOWoodsPage() {
  return (
    <>     
    <StyledSection>
      <Container>
      <Row>
        <Col>
          <Card bg='trans-white'>
            <Card.Body>
              <Card.Title><h1 className='blue-color'>About Moorings at Point O Woods and surrounding areas</h1></Card.Title>
              <Card.Subtitle><h2><a href='https://en.wikipedia.org/wiki/Inverness,_Florida' target='_blank' rel='noopener'>The Moorings at Point O Woods – Inverness, Florida 344650</a></h2></Card.Subtitle>
              <Card.Text as='div'>
                <p className='indent'>The Moorings at Point O Woods is a desirable waterfront residential community located in Inverness, Florida, along the highly sought-after Tsala Apopka Chain of Lakes in Citrus County. This charming neighborhood offers an attractive blend of peaceful lakefront living and convenient access to downtown Inverness, shopping, dining, and recreational opportunities. With a variety of housing options including single-family homes, villas, and waterfront residences, The Moorings appeals to a wide range of buyers seeking comfort, value, and a relaxed Florida lifestyle. Many homes feature canal or lake views, and the community's slightly elevated setting often eliminates the need for flood insurance, providing added financial appeal for homeowners.</p>
                <Row>
                  <Col xs={12} lg={6} className='py-2'>
                  <Ratio aspectRatio='16x9'>
                    <iframe className='w-100' src='https://www.youtube.com/embed?listType=playlist&list=PLjBxLKqSLoEaXkO2Na0aVWnV5L079x9Sh&modestbranding=1&autoplay=0&rel=0&fs=0' allowFullScreen allow='autoplay'></iframe>
                    </Ratio>
                  </Col>
                  <Col xs={12} lg={6} className='py-2'>
                    <Stack gap={2} className='align-items-start'>                    
                      <p className='indent'>
                        Residents of The Moorings enjoy a lifestyle centered on outdoor living and direct water access. Boating, kayaking, fishing, and sunset views over the water are part of everyday life, creating a resort-style atmosphere right at home. The connected waterways of Lake Henderson and the Tsala Apopka Chain offer endless opportunities for recreation, making the community especially attractive to buyers who value an active yet laid-back lifestyle. This balance of natural beauty and accessibility makes The Moorings a standout option for both full-time residents and seasonal homeowners. <br/>
                        The community's homeowners association further enhances its market appeal by offering valuable amenities and services that support low-maintenance living. Residents enjoy access to a private boat ramp and secure boat storage, a heated community pool with cabana, and shuffleboard courts for social and recreational activities. Most HOA fees also include lawn and grounds maintenance, basic cable, high-speed internet, trash service, and upkeep of common areas. Additional features such as underground utilities and street lighting contribute to the neighborhood's clean appearance and overall safety, reinforcing The Moorings at Point O Woods as a strong choice for buyers seeking waterfront living with convenience and long-term value. 
                      </p>
                      <LinkContainer to='/homes-for-sale/Moorings-at-Point-O-Woods' aria-label='homes for sale in Moorings at Point O Woods - Inverness, FL 34450' title='homes for sale in Moorings at Point O Woods - Inverness, FL 34450'>
                        <Button variant='blue'>
                          Moorings at Point O Woods Properties <i role='presentation' className='bi bi-caret-right-fill'></i>
                        </Button>
                      </LinkContainer>  
                        <Button variant='blue' href='/assets/documents/Moorings-at-Point-O-Woods-Welcome-Packet.pdf' aria-label='Moorings at Point O Woods Welcome Packet' title='Moorings at Point O Woods Welcome Packet' target='_blank' rel='noopener'>
                          Moorings at Point O Woods Welcome Packet <i role='presentation' className='bi bi-caret-right-fill'></i>
                        </Button>    
                        <Button variant='blue' href='/assets/documents/Moorings-at-Point-O-Woods-HOA-FAQs.pdf' aria-label='Moorings at Point O Woods HOA FAQs' title='Moorings at Point O Woods HOA FAQs' target='_blank' rel='noopener'>
                          Moorings at Point O Woods HOA FAQs <i role='presentation' className='bi bi-caret-right-fill'></i>
                        </Button>                            
                    </Stack>    
                  </Col>
                </Row>                              
              </Card.Text>              
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className='py-2'>       
          <SlideCarousel className='featured-carousel' slideType='community' queryValue='Moorings-at-Point-O-Woods' count={4} controls={false} cardWrapper={true} bg='trans-black' />              
        </Col>
      </Row>
      </Container>
    </StyledSection>
    </>
  );
}

  
  export default MooringsAtPointOWoodsPage;